import React from "react";
import styles from "./CompletedCard.module.css";
import taskStyles from "../Tasks.module.css";
import High from "../../components/Assets/High.svg";
import Normal from "../../components/Assets/Normal.svg";
import Low from "../../components/Assets/Low.svg";
import Urgent from "../../components/Assets/Urgent.svg";
import moment from "moment";
import "moment-timezone";
import { useNavigate } from "react-router";
import { setToastNotification } from "../../../../../components/ToastNotification/service/toastNotificationSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { checkSubDomainAccess } from "../../../../../components/RolePermissionAccess/RolePermissionAccess";
import getTeamMember from "../../../../../components/CommonFunctions/CommonFunctions";
import { getDescriptionWithMentionedNames } from "../../../../../components/CommonFunctions/CommonFunctions";
import { openLeadExpandModal } from "../../../../../components/LeadPopup/hooks/useLeadCard";
import LoopIcon from "@mui/icons-material/Loop";
import { Tooltip } from "@mui/material";

function CompletedCard(props: any) {
  const {
    taskCompletedPage,
    task,
    expandDisabled,
    employees,
    page,
    handleDragStart,
    onTaskClick,
    highlightedTaskId,
  } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userById } = useSelector((state: any) => state.userDetails);
  const hasLeadCardPermission = checkSubDomainAccess(
    "NURTURE_BOARD",
    "LEAD_CARD",
    userById?.rolePermission
  );

  const modifiedDescription = getDescriptionWithMentionedNames(
    task?.description,
    employees
  );
  const demoPageNavigate = () => {
    if (page === "COMPLETED_TASKS") {
      const currentUrl = window.location.href;
      const pathAfterTaskCompleted = currentUrl.split("Tasks")[1];
      navigate(`/app/Tasks/DemoTaskDetails/${task.id}`, {
        state: { fromCompletedPageUrl: pathAfterTaskCompleted },
      });
    } else {
      navigate(`/app/Tasks/DemoTaskDetails/${task.id}`);
    }
  };

  const taskIdForHighlight = task.id || task.activityId;
  const isHighlighted = highlightedTaskId && (
    String(highlightedTaskId) === String(task.id) ||
    String(highlightedTaskId) === String(task.activityId) ||
    String(highlightedTaskId) === String(taskIdForHighlight)
  );

  return (
    <div
      className={`${styles.taskCompletedCard} ${isHighlighted
        ? styles.highlightedTask
        : ""
        }`}
      id={`task-${taskIdForHighlight}`}
      key={task.id || task.activityId}
      draggable={page === "TASK_BOARD" ? true : false}
      onDragStart={(event) => {
        if (page === "TASK_BOARD") {
          handleDragStart(event, "COMPLETED", task.id, task.taskType, task);
        }
      }}
      onClick={() => {
        if (!expandDisabled) {
          if (task?.taskCategory?.toUpperCase() === "GENERAL_TASK") {
            if (onTaskClick) {
              onTaskClick(task);
            }
          } else if (task.taskType === "DEMO") {
            demoPageNavigate();
          } else if (hasLeadCardPermission) {
            openLeadExpandModal(
              task?.instituteId
                ? task?.instituteId
                : task?.enquiryData?.instituteId,
              task?.studentContact
                ? task?.studentContact
                : task?.enquiryData?.studentContact,
              task?.studentEmail
                ? task?.studentEmail
                : task?.enquiryData?.studentEmail,
              task?.enquiryId,
              dispatch,
              "task",
              task.id,
              "COMPLETED"
            );
          } else {
            dispatch(
              setToastNotification({
                message: String(
                  "You do not have permission to access the lead card"
                ),
                type: "error",
                snackOpen: true,
              })
            );
          }
        }
      }}
      style={{ cursor: !expandDisabled ? "pointer" : "default" }}
    >
      <div
        className={styles.taskCompletedCardSplitTop}
        style={{
          justifyContent: taskCompletedPage ? "flex-start" : "space-between",
        }}
      >
        <div className={styles.taskCompletedCardDate}>
          {task?.taskCategory?.toUpperCase() === "GENERAL_TASK"
            ? moment(task?.taskCompletedDate).tz("Asia/Kolkata").format("DD MMM YYYY, hh:mm A")
            : moment(task?.taskCompletedDate).format("DD MMM YYYY, hh:mm A")}
        </div>
        <div className={styles.taskFlag}>
          <div className={styles.taskCompletedCardType}>
            {task.taskType?.toLowerCase()}
          </div>
          <div className={styles.userCircle}>
            {getTeamMember(task?.assignedToId, employees)?.firstName ===
              undefined
              ? ""
              : getTeamMember(task?.assignedToId, employees)?.firstName?.charAt(
                0
              ) +
              "" +
              getTeamMember(task?.assignedToId, employees)?.lastName?.charAt(
                0
              )}
          </div>
          <div className={styles.flagAssign}>
            {task.priority === "HIGH" && <img src={High} alt="High" />}
            {task.priority === "NORMAL" && <img src={Normal} alt="Normal" />}
            {task.priority === "LOW" && <img src={Low} alt="Low" />}
            {task.priority === "URGENT" && <img src={Urgent} alt="Urgent" />}
          </div>
        </div>
      </div>
      <div className={styles.taskCompletedCardLeadName}>
        {task?.taskType === "DEMO" ? (
          <>{task?.demoData?.[0]?.batchName}</>
        ) : (
          <>{task?.studentName}</>
        )}
      </div>
      {task?.taskCategory && (
        <div style={{ marginTop: "4px", marginBottom: "4px", width: "100%", minWidth: 0, display: "flex", alignItems: "flex-start", gap: "6px" }}>
          <div
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              if (task?.taskCategory?.toUpperCase() === "GENERAL_TASK") {
                if (onTaskClick && typeof onTaskClick === "function") {
                  onTaskClick(task);
                }
              }
            }}
            className={taskStyles.taskDesc}
            style={{
              cursor: task?.taskCategory?.toUpperCase() === "GENERAL_TASK" ? "pointer" : "default",
              color: task?.taskCategory?.toUpperCase() === "GENERAL_TASK" ? "#11C89B" : "#142C44",
              flex: 1,
              minWidth: 0,
            }}
            onMouseEnter={(e) => {
              if (task?.taskCategory?.toUpperCase() === "GENERAL_TASK") {
                e.currentTarget.style.opacity = "0.8";
              }
            }}
            onMouseLeave={(e) => {
              if (task?.taskCategory?.toUpperCase() === "GENERAL_TASK") {
                e.currentTarget.style.opacity = "1";
              }
            }}
          >
            {task?.taskCategory && task?.taskTitle || ""}
            {task?.taskCategory?.toUpperCase() === "GENERAL_TASK" &&
              !!(
                task?.recurringTaskId ||
                task?.recurrence ||
                task?.recurringInfo ||
                task?.isRecurring
              ) && (
                <Tooltip title="Recurrence Task" arrow>
                  <LoopIcon
                    sx={{
                      fontSize: "16px",
                      color: "#11C89B",
                      marginLeft: "6px",
                      verticalAlign: "Middle",
                    }}
                  />
                </Tooltip>
              )}
          </div>

        </div>
      )}
      <div
        className={
          task?.taskCategory?.toUpperCase() === "GENERAL_TASK"
            ? taskStyles.taskDesc
            : taskCompletedPage
              ? styles.taskCompletedCardDesc
              : styles.taskCompletedCardDescShort
        }
        dangerouslySetInnerHTML={{ __html: modifiedDescription }}
        style={
          task?.taskCategory?.toUpperCase() === "GENERAL_TASK"
            ? { width: "100%", minWidth: 0 }
            : undefined
        }
      ></div>
    </div>
  );
}

export default CompletedCard;
